import React from 'react';
import { styled } from '@this/constants/themes';
import moment from 'moment';
import type { Moment } from 'moment';
import { Input } from '@this/shared/ui/inputs/input';
import Calendar from 'rc-calendar';
import { AI_EXPENSE_COLORS } from '../constants/colors';

const DatePicker = require('rc-calendar/lib/Picker');
const jaJP = require('rc-calendar/lib/locale/ja_JP');

const STYLE_ID = 'ai-expense-datepicker-styles';

interface Props {
  id?: string;
  value: string;
  onChange: (value: Moment) => void;
}

type DatePickerChildFunc = (props: { value: Moment }) => void;

const ModalZIndex = 1300;

class DatePickerForSearch extends React.Component<Props> {
  componentDidMount() {
    this.injectStyles();
  }

  componentWillUnmount() {
    this.removeStyles();
  }

  injectStyles = () => {
    if (document.getElementById(STYLE_ID)) {
      return;
    }

    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = `
      /* AI Expense用の日付ピッカー「今日」ボタンの色を新ブランドカラーに変更 */
      .rc-calendar-today-btn {
        color: ${AI_EXPENSE_COLORS.brand.primary} !important;
      }
      .rc-calendar-today-btn:hover {
        color: ${AI_EXPENSE_COLORS.brand.hover} !important;
      }

      /* AI Expense用の日付ピッカー選択中の日付の色を新ブランドカラーに変更 */
      .rc-calendar-selected-date .rc-calendar-date {
        background: ${AI_EXPENSE_COLORS.brand.primary} !important;
        color: #fff !important;
      }
      .rc-calendar-selected-date .rc-calendar-date:hover {
        background: ${AI_EXPENSE_COLORS.brand.primary} !important;
      }

      .rc-calendar-selected-day .rc-calendar-date {
        background: rgba(37, 146, 200, 0.2) !important;
      }

      .rc-calendar-today .rc-calendar-date {
        border-color: ${AI_EXPENSE_COLORS.brand.primary} !important;
      }
    `;
    document.head.appendChild(style);
  };

  removeStyles = () => {
    const style = document.getElementById(STYLE_ID);
    if (style && style.parentNode) {
      style.parentNode.removeChild(style);
    }
  };

  onChange = (value: Moment) => {
    this.props.onChange(value);
  };

  render() {
    const calendar = <Calendar locale={jaJP} />;
    const input: DatePickerChildFunc = () => (
      <TheInput
        id={this.props.id}
        size="small"
        value={this.props.value}
        style={{ width: '100%' }}
        readOnly
        inputProps={{
          placeholder: moment().format('YYYY/MM/DD'),
          style: { fontSize: 14 }
        }}
      />
    );
    return (
      <DatePicker
        style={{ zIndex: ModalZIndex + 1 }}
        calendar={calendar}
        onChange={this.onChange}
        onSelect={this.onChange}
      >
        {input}
      </DatePicker>
    );
  }
}

const TheInput = styled(Input)`
  padding: 10px;
  background: #faf9f8;

  .MuiOutlinedInput-notchedOutline {
    border-color: #e6f7fd;
  }
`;

export default DatePickerForSearch;
